var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChemicalOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_5336_12524)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5336_12524)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8327 13.918H13.916V34.0846H34.0827V13.918H14.8327ZM15.7493 23.0846V20.3346H23.0827V23.0846H15.7493ZM23.0827 24.918H15.7493V27.668H23.0827V24.918ZM24.916 27.668V24.918H27.666V27.668H24.916ZM23.0827 29.5013H15.7493V32.2513H23.0827V29.5013ZM24.916 32.2513V29.5013H27.666V32.2513H24.916ZM29.4993 32.2513H32.2493V29.5013H29.4993V32.2513ZM29.4993 27.668H32.2493V24.918H29.4993V27.668ZM29.4993 23.0846H32.2493V20.3346H29.4993V23.0846ZM27.666 20.3346H24.916V23.0846H27.666V20.3346Z",
    fill: "url(#paint1_linear_5336_12524)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5336_12524",
    x1: 0,
    y1: 0,
    x2: 48,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53CFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5336_12524",
    x1: 23.9993,
    y1: 13.918,
    x2: 23.9993,
    y2: 34.0846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5336_12524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemicalOverview);
export default __webpack_public_path__ + "static/media/chemical-overview.fa45cd2c75db876d1c2053859fbfb67a.svg";
export { ForwardRef as ReactComponent };